/* istanbul ignore file: no need to affect coverage because of purely informational constants */

// fixes ts(2304) -- "Cannot find name"

// The version information will be filled by the build.
export var NewRelicComponentVersion = typeof '4.163.27' !== 'undefined' ? '4.163.27' : 'local';
export var NewRelicComponentName = 'ONECLICK';
export var CW_TEAM_NAME = 'CW';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/constants/newRelic.js
// module id = 876
// module chunks = 11